import React, { FC, useEffect, useState } from 'react';
import { useData } from '@hooks/useData';
import { saveToLocalStorage } from '@utils/storage';

interface UserLocation {
    coordinates: [number, number];
    lastUpdated: string;
    locationAccessGranted: boolean;
}

export const useUserLocation = (allSettings: any) => {
    const [lastLocation, setLastLocation] = useState<UserLocation | null>(null);
    const { setLastLocationSaved } = useData();


useEffect(() => {
    if (!navigator.geolocation) return;

    const watchId = navigator.geolocation.watchPosition(
        (position) => {
            const location = {
                coordinates: [position.coords.latitude, position.coords.longitude] as [number, number],
                lastUpdated: new Date().toISOString(),
                locationAccessGranted: true,
            };
            setLastLocationSaved(location);
            saveToLocalStorage('lastLocationSaved', JSON.stringify(location), 120000);
        },
        (error) => {
            if (error.code === error.PERMISSION_DENIED) {
                if (error.code === error.PERMISSION_DENIED) {
                    const mapCenterJson = allSettings?.data?.['map_center'];

                    if (mapCenterJson) {
                        try {
                            const mapCenter = JSON.parse(mapCenterJson);
                            const latitude = Number(mapCenter.latitude);
                            const longitude = Number(mapCenter.longitude);

                            const locationData = {
                                coordinates: [latitude, longitude],
                                lastUpdated: new Date().toISOString(),
                                locationAccessGranted: false,
                            };

                            setLastLocationSaved({
                                coordinates: [latitude, longitude] as [number, number],
                                lastUpdated: new Date().toISOString(),
                                locationAccessGranted: false,
                            });
                            saveToLocalStorage('lastLocationSaved', JSON.stringify(locationData), 120000);
                        } catch (error) {
                            console.error('Failed to parse map_center JSON:', error);
                        }
                    }
                }
            }
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );

    return () => navigator.geolocation.clearWatch(watchId);
}, [allSettings, setLastLocationSaved]);

    return { lastLocation, setLastLocation };
};